const actions = {
  GET_TRANSACTION_LIST: "transaction/GET_TRANSACTION_LIST",
  SET_TRANSACTION_LIST: "transaction/SET_TRANSACTION_LIST",
  GET_TRANSACTION_DETAIL: "transaction/GET_TRANSACTION_DETAIL",
  SET_TRANSACTION_DETAIL: "transaction/SET_TRANSACTION_DETAIL",
};

export default actions;
